import * as React from 'react';
import { Route, Routes } from 'react-router-dom';

import { MarketingChannel } from './channel/MarketingChannelContainer';
import { MarketingPreferences } from './home/marketingHubContainer';

export const MarketingRoutes = () => {
	return <Routes>
		{/* these routes are prefixed with /marketing  - see main.tsx */}
		<Route path="/" element={<MarketingPreferences />} />
		<Route path="/channel/:channel" element={<MarketingChannel />} />
	</Routes>;
};
